import * as React from 'react';
export const worldcoinSvg = React.forwardRef(function worldcoinSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4c6.617 0 11.983 5.356 11.999 11.97l.002.03-.002.03C27.983 22.642 22.618 28 16 28 9.373 28 4 22.627 4 16S9.373 4 16 4ZM6.317 17.125C6.875 21.98 10.996 25.75 16 25.75a9.72 9.72 0 0 0 7.05-3.018h-7.158a6.733 6.733 0 0 1-6.637-5.607H6.317Zm5.235 0a4.484 4.484 0 0 0 4.34 3.357h8.767a9.682 9.682 0 0 0 1.026-3.357H11.552Zm4.342-5.607h-.002a4.485 4.485 0 0 0-4.34 3.357h14.133a9.682 9.682 0 0 0-1.034-3.372l-8.757.015ZM16 6.25c-5.004 0-9.125 3.77-9.683 8.625h2.938A6.732 6.732 0 0 1 15.89 9.27v-.001l7.15-.013A9.721 9.721 0 0 0 16 6.25Z',
      fill: '#474E5A',
    }),
  );
});
worldcoinSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var worldcoin = {
  category: 'brand',
  colorable: false,
  name: 'worldcoin',
  svg: worldcoinSvg,
};
